import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "check-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M6.96 10.105 4.3 7.24a.75.75 0 1 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.133-.039l5.25-6.5a.75.75 0 0 0-1.166-.942L6.96 10.105z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
